var React = require('react');

function Error (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.75 8.75H7.25V5H8.75V8.75ZM8 11C7.55 11 7.25 10.7 7.25 10.25C7.25 9.8 7.55 9.5 8 9.5C8.45 9.5 8.75 9.8 8.75 10.25C8.75 10.7 8.45 11 8 11ZM8 2C4.7 2 2 4.7 2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8C14 4.7 11.3 2 8 2Z","fill":"#181818"}));
}

Error.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Error;

Error.default = Error;
